<template>
  <div class="test-item">
    <div class="test-item-tigan">
      <div v-html="data.questionBody"></div>
      <div v-if="showSound==true&&data.questionSound"><span class="icon iconfont iconyinpin hand "
                                                            @click=playSound(data.questionSound)></span></div>
      <audio :src="data.questionSound" :id="'test'+data.questionId"></audio>
    </div>
    <div class="test-item-questionOpt" v-for="item in data.questionOpt"><label v-if="item.value==1"><input
        type="checkbox" :name="'checkbox-item'+data.questionId" disabled="disabled" checked="checked"/><span>{{item.option}}</span></label><label
        v-else><input type="checkbox" :name="'checkbox-item'+data.questionId"
                      disabled="disabled"/><span>{{item.option}}</span></label>
    </div>
    <div class="test-item-daan" v-if="showAnswer">
      <el-tag size="small" type="success " style="margin-right:1em">答案</el-tag>
      {{data.questionAnswer.toString()}}
    </div>
    <div class="test-item-jiexi" v-if="showResolve">
      <el-tag size="small" type="success " style="margin-right:1em">解析</el-tag>
      <p v-html="data.questionResolve"></p></div>
    <div class="test-item-createtime" v-if="showTimer">创建于：{{data.createTimeStr}}</div>
  </div>
</template>

<script>
  export default {
    name: 'TestItemMultiple',
    props: {
      data: {
        required: true
      },
      showAnswer: {
        type: Boolean,
        default: true
      },
      showResolve: {
        type: Boolean,
        default: true
      },
      showTimer: {
        type: Boolean,
        default: true
      },
      showSound: {
        type: Boolean,
        default: true
      },
      testIndex: {
        type: Number,
        default: 1
      },
      testPoint: {
        type: Number,
        default: 0
      }
    },
    methods: {
      playSound(val) {
        var audio = document.getElementsByTagName('audio');
        for (var i = 0; i < audio.length; i++) {
          audio[i].pause();
        }
        let player = document.querySelector('#test' + this.data.questionId);
        if (player.paused) {
          player.play();
        } else {
          player.pause();
        }
      }
    },
    created() {
      if (this.data.questionSound === '') {
        this.data.questionSound = null;
      }
      var questionOpt = JSON.parse(decodeURIComponent(this.data.questionOpt));
      this.data.questionAnswer = decodeURIComponent(this.data.questionAnswer).split('#&&&#');
      var arr = questionOpt;
      var arr2 = [];
      for (var i = 0; i < arr.length; i++) {
        var obj = {};
        for (var j = 0; j < this.data.questionAnswer.length; j++) {
          if (arr[i].option == this.data.questionAnswer[j]) {
            obj.value = 1;
            obj.option = arr[i].option;
            break;
          } else {
            obj.value = 0;
            obj.option = arr[i].option;
          }
        }
        arr2.push(obj);
      }
      this.data.questionOpt = arr2;
      this.data.questionResolve = decodeURIComponent(this.data.questionResolve);
      if (this.data.questionBody) {
        var questionBody = decodeURIComponent(this.data.questionBody);
        var index = this.testIndex <= 0 ? '' : this.testIndex + '. ';
        var point = this.testPoint <= 0 ? '' : '（' + this.testPoint + '分）';
        this.data.questionBody = index + point + questionBody;
      }
    }
  };
</script>

<style scoped>

</style>
